const X_AXIS_TYPE = Object.freeze({
    DEFAULT: 'DEFAULT',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
});

const Y_AXIS_TYPE = Object.freeze({
    DEFAULT: 'DEFAULT',
    CURRENCY: 'CURRENCY',
    PERCENT: 'PERCENT',
});

const CHART_TYPE = Object.freeze({
    BAR: 'bar',
    PIE: 'pie',
    LINE: 'line',
    TREEMAP: 'treemap',
    SUNBURST: 'sunburst',
    DOUGHNUT: 'doughnut',
});

const TOTAL_TYPE = Object.freeze({
    AVERAGE: 'AVERAGE',
    SUM: 'SUM',
});

const REVFLOW_REPORT = {
    SUMMARY: 'Summary',
    ROOMS: 'Rooms',
    REVENUE: 'Revenue',
    ADR: 'ADR',
    REVPAR: 'RevPar',
    OCCUPANCY: 'Occupancy',
    ROOM_TYPES: 'Room Types',
    RATE_CODES: 'Rate Codes',
    SOURCES: 'Sources',
    SEGMENT_BUCKETS: 'Segment Buckets',
    LOS: 'Length Of Stay',
};

export { X_AXIS_TYPE, Y_AXIS_TYPE, CHART_TYPE, TOTAL_TYPE, REVFLOW_REPORT };
